<template>
    <GridRow>
        <div :class="[classes]">
            <h5 v-if="title">{{ title ?? "" }}</h5>
            <p v-if="description">
                <small>
                    {{ description ?? "" }}
                </small>
            </p>
        </div>
        <div class="col-md">
            <slot></slot>
        </div>
    </GridRow>
</template>

<script>
import GridRow from './grid/GridRow.vue';

export default {
    components: {
        GridRow,
    },
    props: {
        title: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        isFieldsetRow: {
            type: Boolean,
            default: false,
        },
        center: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        classes() {
            return {
                "col-md-4": !this.isFieldsetRow,
                "text-center": this.center,
                "col-md-12": this.isFieldsetRow,
            }
        },
    }
}
</script>